import { createContext, useContext, useMemo, useState } from "react";
import { storage } from "../lib/storage";
import { DEFAULT_SETTINGS, normalizeSettings } from "../lib/settings";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(() =>
        normalizeSettings(storage.getSettings() || DEFAULT_SETTINGS),
    );

    const api = useMemo(
        () => ({
            settings,
            updateSettings(patch) {
                const next = normalizeSettings({
                    ...settings,
                    ...patch,
                    updatedAt: new Date().toISOString(),
                });
                setSettings(next);
                storage.saveSettings(next);
                return next;
            },
        }),
        [settings],
    );

    return (
        <SettingsContext.Provider value={api}>{children}</SettingsContext.Provider>
    );
}

export function useSettings() {
    const ctx = useContext(SettingsContext);
    if (!ctx) {
        throw new Error("useSettings must be used within SettingsProvider");
    }
    return ctx;
}
